import { Collection, Feature, Map } from "ol";
import { Modify } from "ol/interaction";
import { ModifyEvent } from "ol/interaction/Modify";
import { useEffect, useState } from "react";

export function useModify(
	map: Map | null,
	features: Collection<Feature>,
	onUpdate: (features: Feature[]) => void,
) {
	const [modify] = useState(new Modify({ features }));

	useEffect(() => {
		if (!map) return () => {};

		modify.setActive(false);

		const onModifyEnd = (e: ModifyEvent) => {
			//onUpdate(e.features.getArray());
		};

		modify.on("modifyend", onModifyEnd);
		map.addInteraction(modify);

		return () => {
			map.removeInteraction(modify);
			modify.un("modifyend", onModifyEnd);
		};
	}, [map, modify, onUpdate]);

	return modify;
}